import { Button, TextInput } from "@components/library";
import { SSOEnabledHint } from "@components/SSOEnabledHint";
import { ChangeEvent, Dispatch, FormEvent, SetStateAction, useState } from "react";
import Validator from "validator";
import { LinkButton } from "./SignUpModal";
import { ErrorMessage, Form, Inputs } from "./SignUpModalDefaultForm";

interface Props {
  setShouldShowSSO: Dispatch<SetStateAction<boolean>>;
  email: string;
  setEmail: Dispatch<SetStateAction<string>>;
  isEmailSSOEnabled: boolean;
  redirectToSSO: () => void;
}

const SignUpModalSSOForm = ({
  setShouldShowSSO,
  email,
  setEmail,
  isEmailSSOEnabled,
  redirectToSSO,
}: Props) => {
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setHasSubmitted(true);

    if (email.trim().length === 0 || !Validator.isEmail(email)) return;

    if (!isEmailSSOEnabled) {
      setErrorMessage("Your email/company is not enabled to use SSO.");
      return;
    }

    redirectToSSO();
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Inputs>
        <TextInput
          value={email}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
          placeholder="Company or university email"
          hideClearButton
          errors={[
            {
              hasError: hasSubmitted && !Validator.isEmail(email),
              errorMessage: "Please enter a valid email address.",
            },
          ]}
        />
        <SSOEnabledHint />
      </Inputs>
      <Button type="submit" variant="marketing" disabled={email.trim().length === 0} width="100%">
        Continue
      </Button>
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
      <LinkButton type="button" onClick={() => setShouldShowSSO(false)}>
        Use email/password instead
      </LinkButton>
    </Form>
  );
};

export default SignUpModalSSOForm;
